import Styled from 'styled-components';

export const IFrameWrapper = Styled.iframe`
    width: 100%;
    height: ${props => (props.isLoading ? '0' : '75vh')}
    border: none;
    src: ${props => props.src}
`;
